import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission, } from '../../utils_v2';
import { globalGetService, globalPutService } from '../../../globalServices';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const TARegulatoryComp = ({ params, assetInfoData }) => {
  const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [regulatoryCompInfo, setRegulatoryCompInfo] = useState({});
  useEffect(() => {
    getRegulatoryCompInfo('skeletonLoader');
  }, []);
  const getRegulatoryCompInfo = (loaderType) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/regulatory_compliance/`)
      .then(response => {
        if (checkApiStatus(response)) {
          setRegulatoryCompInfo(response.data.data);
        }
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      })
  }
  const onFieldChange = (key, value) => {
    setRegulatoryCompInfo({ ...regulatoryCompInfo, [key]: value });
  }
  const onEditRegulatoryCompInfo = () => {
    setLoading(true);
    let payload = Object.assign({}, regulatoryCompInfo)
    globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/regulatory_compliance/`, payload)
      .then(response => {
        if (checkApiStatus(response)) {
          enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
          getRegulatoryCompInfo('pageloader')
          trackActivity('Console Management', {data:JSON.stringify(payload), page_title: 'Regulatory Compliance(Titan Aviation)', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Regulatory Compliance Details data from Edit Regulatory Compliance Details form' });
          setEdit(false);
        }
        setLoading(false);
      })
  }
  return (
    <div style={{ position: 'relative' }}>
      <div className="console-forms-fields" style={{ height: `${(window.innerHeight - (isEdit ? 260 : 215)) - navTitleOffset}px`, padding: '10px', overflow: 'auto' }}>
        <p style={{ textAlign: 'right', height: '20px' }}>
          {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
            <span style={{ cursor: 'pointer' }}>
              <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
            </span> : null
          }
        </p>
        {skeletonLoader ? < STableLoader count={3} size={7} /> : <>
          <Grid container spacing={1}>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='future_navigation_system'
                label='Future Aircraft Navigation Systems'
                value={regulatoryCompInfo?.future_navigation_system || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('future_navigation_system', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='tcas '
                label='TCAS 7.1 Capable'
                value={regulatoryCompInfo?.tcas || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('tcas', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='elementary_surveillance'
                label='Elementary Surveillance'
                value={regulatoryCompInfo?.elementary_surveillance || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('elementary_surveillance', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='enhanced_surveillance'
                label='Enhanced Surveillance'
                value={regulatoryCompInfo?.enhanced_surveillance || ''}
                fullWidth
                inputProps={{ maxLength: 255 }}
                margin="normal"
                onChange={(e) => onFieldChange('enhanced_surveillance', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='fm_immunity'
                label='FM Immunity'
                value={regulatoryCompInfo?.fm_immunity || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('fm_immunity', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='vhf_833_channel_spacing'
                label='VHF Comm 8.33 KHz Channel Spacing'
                value={regulatoryCompInfo?.vhf_833_channel_spacing || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('vhf_833_channel_spacing', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='low_frequency_ulb'
                label='Low Frequency ULB'
                value={regulatoryCompInfo?.low_frequency_ulb || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('low_frequency_ulb', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='cvr_dfdr_90_day_ulb'
                label='CVR / DFDR 90 Day ULB'
                value={regulatoryCompInfo?.cvr_dfdr_90_day_ulb || ''}
                fullWidth
                inputProps={{ maxLength: 255 }}
                margin="normal"
                onChange={(e) => onFieldChange('cvr_dfdr_90_day_ulb', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='cockpit_voice_recorder_120min'
                label='Cockpit Voice Recorder 120 Minutes'
                value={regulatoryCompInfo?.cockpit_voice_recorder_120min || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('cockpit_voice_recorder_120min', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='elt_121_5_406'
                label='ELT 121.5/406 MHz'
                value={regulatoryCompInfo?.elt_121_5_406 || ''}
                fullWidth
                inputProps={{ maxLength: 255 }}
                margin="normal"
                onChange={(e) => onFieldChange('elt_121_5_406', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            {[1, 3].includes(assetInfoData?.aircraft_operation?.value) ?
              <Grid item md={4}>
                <TextField
                  disabled={!isEdit}
                  name='head_injury_criteria_16g'
                  label='Head Injury Criteria Certification / 16G'
                  value={regulatoryCompInfo?.head_injury_criteria_16g || ''}
                  fullWidth
                  margin="normal"
                  inputProps={{ maxLength: 255 }}
                  onChange={(e) => onFieldChange('head_injury_criteria_16g', e.target.value.trimStart())}
                  InputLabelProps={{ shrink: true }}
                  variant='outlined'
                />
              </Grid> : null}
          </Grid>
        </>}
      </div>
      {isEdit ?
        <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
          <ul className="list-inline">
            <li className="list-inline-item">
              <Button onClick={() => { setEdit(false); getRegulatoryCompInfo() }} color="primary" size='small' variant="outlined">Cancel</Button>
            </li>
            <li className="list-inline-item">
              <Button onClick={onEditRegulatoryCompInfo} color="primary" size='small' variant="contained">SAVE</Button>
            </li>
          </ul>
        </Paper> : null
      }
      {isLoading ? <PageLoader /> : null}
    </div>
  )
}
export default withRouter(TARegulatoryComp);